export default {
  name: "email",
  in: "query",
  required: false,
  description: "Filtration based on user email",
  schema: {
    type: "string",
    example: "john@doe.com"
  }
};
